import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579d9670"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-token-cart-item-delete"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_token_cart_delete = _resolveComponent("m-token-cart-delete")!

  return (_ctx.showDelete)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_m_token_cart_delete)
      ]))
    : _createCommentVNode("", true)
}